module.exports = __webpack_public_path__ + "static/media/NIFTY_F1.a2700792.txt";